/**
 * Mimu — 15 minute cart hold, shown in the cart drawer and on the cart page.
 *
 * The deadline lives in localStorage, not in memory: a page navigation must not
 * silently restart the clock, or it would never expire for anyone who keeps
 * browsing. It resets whenever the cart's contents change, detected by comparing a
 * signature of item count and total against the last one seen.
 *
 * On expiry the cart is cleared through /cart/clear.js and the page reloads, since
 * every rendered total on screen is stale the moment the cart empties.
 *
 * Guards worth knowing:
 *  - An empty cart has no timer at all, and clears any stored deadline.
 *  - Clearing is attempted once, behind a lock, so two open tabs cannot both fire.
 *  - A tab that has been hidden past the deadline re-checks on becoming visible
 *    rather than clearing blind in the background.
 */
(function () {
  var HOLD_MS = 15 * 60 * 1000;
  var DEADLINE_KEY = 'mimu:cart-deadline';
  var SIGNATURE_KEY = 'mimu:cart-signature';
  var LOCK_KEY = 'mimu:cart-clearing';

  var timer = null;
  var clearing = false;

  function store(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) { /* private mode */ }
  }
  function read(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function drop(key) {
    try { window.localStorage.removeItem(key); } catch (e) { /* private mode */ }
  }

  function paint(msLeft) {
    var nodes = document.querySelectorAll('[data-mimu-cart-timer]');
    if (!nodes.length) return;

    var show = msLeft > 0;
    var total = Math.max(0, Math.ceil(msLeft / 1000));
    var text = Math.floor(total / 60) + ':' + ('0' + (total % 60)).slice(-2);

    Array.prototype.forEach.call(nodes, function (node) {
      if (node.hidden === !show) node.hidden = !show;
      var value = node.querySelector('[data-mimu-cart-timer-value]');
      if (value && value.textContent !== text) value.textContent = text;
    });
  }

  function expire() {
    if (clearing) return;
    // Cross-tab lock, so two open tabs do not both post a clear.
    if (read(LOCK_KEY)) return;
    clearing = true;
    store(LOCK_KEY, '1');

    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: '{}'
    })
      .then(function () {
        drop(DEADLINE_KEY);
        drop(SIGNATURE_KEY);
        drop(LOCK_KEY);
        window.location.reload();
      })
      .catch(function () {
        drop(LOCK_KEY);
        clearing = false;
      });
  }

  function tick() {
    var deadline = parseInt(read(DEADLINE_KEY) || '0', 10);
    if (!deadline) return paint(0);

    var left = deadline - Date.now();
    paint(left);

    if (left > 0) return;
    // Do not empty a cart from a tab nobody is looking at; wait until it is seen.
    if (document.hidden) return;
    expire();
  }

  function sync() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) {
          drop(DEADLINE_KEY);
          drop(SIGNATURE_KEY);
          paint(0);
          return;
        }

        var signature = cart.item_count + ':' + cart.total_price;
        if (signature !== read(SIGNATURE_KEY)) {
          // Contents changed — the hold starts again.
          store(SIGNATURE_KEY, signature);
          store(DEADLINE_KEY, String(Date.now() + HOLD_MS));
        } else if (!read(DEADLINE_KEY)) {
          store(DEADLINE_KEY, String(Date.now() + HOLD_MS));
        }
        tick();
      })
      .catch(function () { /* leave the last known state alone */ });
  }

  document.addEventListener('cart:update', sync);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) sync();
  });
  window.addEventListener('pageshow', sync);

  timer = setInterval(tick, 1000);
  sync();
})();
